import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V7H17V16ZM10 14C9.82812 14 9.69271 14.0508 9.59375 14.1523C9.4974 14.2539 9.44922 14.3776 9.44922 14.5234C9.44922 14.6719 9.4974 14.7956 9.59375 14.8945C9.69271 14.9935 9.82812 15.043 10 15.043C10.1719 15.043 10.306 14.9935 10.4023 14.8945C10.5013 14.7956 10.5508 14.6719 10.5508 14.5234C10.5508 14.3776 10.5013 14.2539 10.4023 14.1523C10.306 14.0508 10.1719 14 10 14ZM10.207 9.23438C9.88932 9.23438 9.60156 9.29167 9.34375 9.40625C9.08854 9.51823 8.88542 9.6862 8.73438 9.91016C8.58333 10.1341 8.50521 10.4141 8.5 10.75H9.46875C9.47135 10.5 9.54818 10.319 9.69922 10.207C9.85026 10.0924 10.0195 10.0352 10.207 10.0352C10.4362 10.0352 10.6107 10.1003 10.7305 10.2305C10.8503 10.3607 10.9102 10.5456 10.9102 10.7852C10.9102 10.931 10.8815 11.0599 10.8242 11.1719C10.7669 11.2839 10.6901 11.3906 10.5938 11.4922C10.4974 11.5938 10.3893 11.7018 10.2695 11.8164C10.1159 11.9648 9.99349 12.1068 9.90234 12.2422C9.8112 12.3776 9.74609 12.5299 9.70703 12.6992C9.66797 12.8659 9.64714 13.0703 9.64453 13.3125H10.5391C10.5417 13.1146 10.5677 12.9388 10.6172 12.7852C10.6667 12.6315 10.7643 12.4896 10.9102 12.3594C11.0794 12.2005 11.237 12.0417 11.3828 11.8828C11.5312 11.7214 11.651 11.5495 11.7422 11.3672C11.8333 11.1849 11.8789 10.9779 11.8789 10.7461C11.8789 10.2669 11.7318 9.89583 11.4375 9.63281C11.1432 9.36719 10.7331 9.23438 10.207 9.23438Z"
      fill="#24275B"
    />
    <path
      d="M14 2C14.5523 2 15 2.44772 15 3H16C16.5523 3 17 3.44772 17 4V6H3V4C3 3.44772 3.44772 3 4 3H5C5 2.44772 5.44772 2 6 2C6.55228 2 7 2.44772 7 3H13C13 2.44772 13.4477 2 14 2Z"
      fill="#24275B"
    />
  </svg>
);
